import {PermissionTargetEnum} from './enums/PermissionTargetEnum';
import {IconProp} from '@fortawesome/fontawesome-svg-core';

export default {
  MENU: [
    {
      name: 'Allgemein',
      items: [
        {
          name: 'Dashboard',
          icon: ['fas', 'box-open'] as IconProp,
          link: 'dashboard',
          permissions: [PermissionTargetEnum.NO_PERMISSION]
        },
        {
          name: 'Firmware',
          icon: ['fas', 'microchip'] as IconProp,
          link: 'firmware',
          permissions: [PermissionTargetEnum.FIRMWARE]
        },
        {
          name: 'Modul Typen',
          icon: ['fas', 'tags'] as IconProp,
          link: 'module-type',
          permissions: [PermissionTargetEnum.MODULE_TYPE]
        },
        {
          name: 'Display Typen',
          icon: ['fas', 'tv'] as IconProp,
          link: 'display-type',
          permissions: [PermissionTargetEnum.DISPLAY_TYPE]
        },
        {
          name: 'Chip Typen',
          icon: ['fas', 'microchip'] as IconProp,
          link: 'chip-type',
          permissions: [PermissionTargetEnum.CHIP_TYPE]
        },
        {
          name: 'Dateien',
          icon: ['fas', 'file'] as IconProp,
          link: 'files',
          permissions: [PermissionTargetEnum.FILES]
        }
      ]
    },
    {
      name: 'Administration',
      items: [
        {
          name: 'Benutzer',
          icon: ['fas', 'user'] as IconProp,
          link: 'users',
          permissions: [PermissionTargetEnum.USERS]
        },
        {
          name: 'Gruppen',
          icon: ['fas', 'users'] as IconProp,
          link: 'groups',
          permissions: [PermissionTargetEnum.GROUPS]
        },
        {
          name: 'Berechtigungen',
          icon: ['fas', 'lock'] as IconProp,
          link: 'permissions',
          permissions: [PermissionTargetEnum.PERMISSIONS]
        }
      ]
    }
  ]
};
